<template>
    <div
        :class="[
            {
                'form-row': horizontal,
            },
        ]"
    >
        <label
            v-if="label"
            :class="[
                { 'col-form-label': horizontal },
                getClassLabel(),
                size == 'sm' ? 'col-form-label-sm' : '',
            ]"
        >
            {{ label }}
        </label>
        <div
            class="form-group"
            :class="[
                getClassInput(),
                size == 'sm' ? 'input-group-sm' : '',
            ]"
        >
            <div
                :class="[{ 'form-check-inline': inline }]"
                class="form-check"
                v-for="(option, index) in options"
                :key="index"
            >
                <input
                    class="form-check-input"
                    type="radio"
                    :value="option.value"
                    v-model="itemSelect"
                    :id="sufixRamdom + option + index"
                    :disabled="disabled"
                    :class="[
                        {
                            'is-valid': isValid == true,
                            'is-invalid': isValid == false,
                        },
                    ]"
                />
                <label class="form-check-label" :for="sufixRamdom + option + index">
                    {{ option.label }}
                </label>
            </div>
        </div>
    </div>
</template>

<script>

import baseMixin from "~/mixins/base.js";

export default {
    name: "LInputRadioGroup",
    data() {
        return {
            itemSelect: null,
            classLabel: "col-sm-3",
            classInput: "col-sm-9",
            sufixRamdom: this.generateStringRamdom()
        };
    },
    mixins: [baseMixin],
    props: {
        isValid: {
            type: Boolean,
            default: null,
        },
        checked: {
            default: null,
        },
        options: {
            default: undefined,
        },
        size:{
            default: undefined
        },
        horizontal: {
            type: Boolean|Object,
            default: false,
        },
        invalidFeedback: {
            default: undefined,
        },
        disabled: {
            default: false,
        },
        inline: {
            default: false,
        },
        label: {},
    },
    watch: {
        itemSelect(newValue) {
            this.$emit("update:checked", newValue);
            this.$emit("change", newValue);
        },
        checked(newValue) {
            this.itemSelect = newValue;
        }
    },
    methods: {
        getClassLabel(){
            if(this.horizontal === true){
                return this.classLabel;
            }else if (this.horizontal.label){
                return this.horizontal.label
            }
            return "";
        },
        getClassInput(){
            if(this.horizontal === true){
                return this.classInput;
            }else if (this.horizontal.input){
                return this.horizontal.input
            }
            return "";
        }
    },
    async mounted() {
        this.itemSelect = this.checked;
    },
};
</script>

<style>
</style>